module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/ml-dog-1800.21300feeca1cefe9.jpg"+" 1800w",
        images: [{path: "https://static.sniffspot.com/packs/img/ml-dog-1800.21300feeca1cefe9.jpg",width: 1800,height: 1205}],
        src: "https://static.sniffspot.com/packs/img/ml-dog-1800.21300feeca1cefe9.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/ml-dog-1800.21300feeca1cefe9.jpg"},
        
        width: 1800,
        height: 1205
      }